












import { Content } from '@front-app/services/GroupsApi/DiscussionModel';
import { defineComponent, PropType } from '@vue/composition-api';
import DiscussionMessageCard from '../cards/discussion/DiscussionMessageCard.vue';

export default defineComponent({
	components: {
		DiscussionMessageCard,
	},
	props: {
		content: {
			type: Object as PropType<Content>,
			required: true,
		},
	},
});
